/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import IconLink from './IconLink';

import styles from '../../../styles/partials/notification-panel.module.scss';

const propTypes = {
    label: AppPropTypes.message,
    active: PropTypes.bool,
    buttonLabel: AppPropTypes.message,
    horizontal: PropTypes.bool,
    rounded: PropTypes.bool,
    small: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = {
    label: null,
    active: false,
    buttonLabel: null,
    horizontal: false,
    rounded: false,
    small: false,
    className: null,
    children: null,
};

const NotificationPanel = ({
    label,
    active,
    small,
    rounded,
    horizontal,
    buttonLabel,
    className,
    children,
    ...props
}) => (
    <div
        className={classNames([
            styles.container,
            {
                [styles.horizontal]: horizontal,
                [styles.rounded]: rounded,
                [styles.small]: small,
                [className]: className !== null,
            },
        ])}
    >
        <p className={styles.label}>{label}</p>
        <div>
            {children}
            {active && buttonLabel ? (
                <IconLink className={styles.button} {...props}>
                    <span>{buttonLabel}</span>
                </IconLink>
            ) : null}
            {!active && buttonLabel ? (
                <div className={styles.button} {...props}>
                    <span className={styles.strong}>{buttonLabel}</span>
                </div>
            ) : null}
        </div>
    </div>
);
NotificationPanel.propTypes = propTypes;
NotificationPanel.defaultProps = defaultProps;

export default NotificationPanel;
